import React from 'react'
import {clone} from 'lodash'
import {
  Card,
  CardActions,
  CardText,
  CardTitle
} from 'material-ui-legacy/Card'
import TextField from 'material-ui-legacy/TextField'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'

import ValidatedTextInput from '../UI/ValidatedTextInput'
import SaveButton from '../UI/SaveButton'
import CancelButton from '../UI/CancelButton'

import FormulaTypeSelect from './FormulaTypeSelect'
import FormulaInput from './FormulaInput'


/*
Props:
- formula: a complete formula object
  or
- Formula fields: will be inserted in the form when present
- submitCallback: callback function called on form submission. This is *only*
  called when the form is valid and the contents have changed. Receives formula
  attributes.
- cancelCallback: callback function for the cancel button.
- changedCallback: callback function called when the form contents have changed.
  Receives true if the contents have changed.
- forceChanged: force the form status to "changed"
*/
class FormulaForm extends React.PureComponent {
  constructor(props) {
    super(props)
    // We have to build the state on a regular variable so
    // React doesn't complain about direct state mutation.
    let initialState = {
      formValid: false,
      formChanged: (this.props.forceChanged || false),
      formSubmitted: false
    }

    // We can either receive a single data prop or each field separately
    this.initialData =
      (this.props.formula) ?
      clone(this.props.formula.attributes) :
      clone(this.props)

    // The `formula` field is an array, so we need to adjust it when blank
    this.initialData.formula = this.initialData.formula || []

    this.fields = [
      'type',
      'name',
      'formula',
      'formulaType',
      'notes'
    ]
    for (let field of this.fields) {
      initialState[field] = {
        value: (this.initialData[field] || ''),
        valid: true
      }
    }
    this.state = initialState // Et voilà!
  }

  componentDidMount() {
    if (this.props.forceChanged) this._validateForm()
  }

  _submit = () => {
    // Don't do anything if we have invalid fields or no changes.
    if (!this.state.formValid || !this.state.formChanged) return

    let attributes = {}
    for (let field of this.fields) {
      attributes[field] = this.state[field].value
    }
    this.props.submitCallback(attributes)
    this.setState({formChanged: false, formSubmitted: true})
  }

  _change = (value, valid, attribute) => {
    let updates = {}
    updates[attribute] = {value: value, valid: valid}
    this.setState(
      updates,
      () => {
        this._checkForChanges()
        this._validateForm()
      }
    )
  }

  _checkForChanges = () => {
    let changed = (this.props.forceChanged || false)
    for (let field of this.fields) {
      let current = this.state[field].value
      let original = this.initialData[field] || ''
      if (current !== original) {
        changed = true
        break
      }
    }
    this.setState(
      {formChanged: changed},
      () => {
        if (this.props.changedCallback) {
          this.props.changedCallback(this.state.formChanged)
        }
      }
    )
  }

  _validateForm = () => {
    let allValid = true
    for (let field of this.fields) {
      if (!this.state[field].valid) {
        allValid = false
        break
      }
    }
    this.setState({formValid: allValid})
  }

  render() {
    return (
      <Card>
        {this.props.formTitle && <CardTitle title={this.props.formTitle} />}
        <CardText>

          <Row>
            <Col lg="12" md="12">
              <p>
                Compose a formula using reference values, operators or other formulas. The end result <strong>must</strong> be a dollar value.<br/>
                The formula will be continuosuly tested every time a new element is added or removed.
              </p>
            </Col>
          </Row>

          <Row>
            <Col lg="9" md="9" sm="12">
              <ValidatedTextInput
                name="name"
                required={true}
                errorMessage="Name is required"
                hintText="Formula name"
                floatingLabelText="Name (required)"
                fullWidth={true}
                value={this.state.name.value}
                validatedOnChange={this._change}
              />
            </Col>
            <Col lg="3" md="3" sm="12">
              <FormulaTypeSelect
                floatingLabelText="Formula type (required)"
                required={true}
                value={this.state.formulaType.value}
                onChange={(ev, key, value) => this._change(value, true, 'formulaType')}
              />
            </Col>
          </Row>

          <Row>
            <Col lg="12" md="12">
              <TextField
                name="notes"
                value={this.state.notes.value}
                hintText="Notes about this formula, explanation etc."
                floatingLabelText="Notes"
                multiLine={true}
                fullWidth={true}
                onChange={(ev, value) => this._change(value, true, 'notes')}
              />
            </Col>
          </Row>


          <Row>
            <Col lg="12" md="12">
              <FormulaInput
                name="formula"
                formula={this.state.formula.value}
                validatedOnChange={this._change}
              />
            </Col>
          </Row>

        </CardText>

        <CardActions style={{textAlign: 'center'}}>
          {this.props.submitCallback &&
            <SaveButton
              type="submit"
              disabled={!this.state.formChanged || !this.state.formValid}
              onTouchTap={this._submit}
            />
          }
          {this.props.cancelCallback &&
            <CancelButton
              onTouchTap={this.props.cancelCallback}
              disabled={!this.state.formChanged && this.state.formSubmitted}
            />
          }
        </CardActions>

      </Card>
    )
  }
}

export default FormulaForm



// WEBPACK FOOTER //
// ./src/components/Formulas/FormulaForm.jsx